import apiClient from './apiClient';

export interface P5M1ActionResponse {
  success: number;
  message: string;
}

export const p5m1Api = {
  async reverse(requestNo: string): Promise<P5M1ActionResponse> {
    const response = await apiClient.post('/api/p5m1/reverse', {
      confirmed: true,
      items: [{ no: requestNo, checked: true }],
    });
    return response.data;
  },
};

export default p5m1Api;
